var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"mini-apps-header"},[(!_vm.openedFolder)?_c('CreateFolder',{attrs:{"folders":_vm.folders}}):_vm._e(),(_vm.openedFolder || _vm.isCephStorage)?_c('Upload',{attrs:{"opened":_vm.opened},on:{"refresh":function($event){return _vm.$emit('refresh')}}}):_vm._e(),(_vm.selectedNotEmpty)?_c('Delete',{attrs:{"selected":_vm.selected},on:{"afterDelete":() => {
        _vm.$emit('refresh');
        _vm.$emit('setSelected', {});
      }}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }